module.exports = __webpack_public_path__ + "static/img/smarttwo.bd348c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default/smarttwo.png
// module id = NGV7
// module chunks = 2 4